class AnchorBlock {
    constructor(element) {
        this.anchor = element;

        this.tabBtn = false;

        const whichFeed = this.getWhichFeed();

        if (whichFeed == "playhouse" && location.hash.includes("playhouse")) {
            this.tabBtn = document.getElementById("playhouse-tab");
            this.tabBtn.click();
        } else if (
            whichFeed == "everyman" &&
            location.hash.includes("everyman")
        ) {
            this.tabBtn = document.getElementById("everyman-tab");
        }

        if (this.tabBtn) {
            this.anchor.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }

    getWhichFeed() {
        const parentFeed = this.anchor?.closest("div[data-feed]");

        if (parentFeed) {
            return parentFeed.getAttribute("data-feed");
        } else {
            return "";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const anchorBlocks = document.querySelectorAll("[data-anchor-component]");

    if (anchorBlocks) {
        anchorBlocks.forEach((anchor) => {
            new AnchorBlock(anchor);
        });
    }
});

export default AnchorBlock;
